import { Button, Header, Modal } from 'semantic-ui-react';
import React from 'react';
import RepositoryContentList from './RepositoryContentList';
import repositoryApi from '../api/repositoryApi';
import { RepositoryFileRead } from '../../../../store/generated/admin/repository-files';

type RepositoryContentListModalProps = {
  open: boolean;
  onClose: () => void;
  onItemClicked: (repositoryFile: RepositoryFileRead) => void;
};
const RepositoryContentListModal = (props: RepositoryContentListModalProps) => {
  // This modal is one of the more interesting cases of a lack of a definitive
  const { data } = repositoryApi.useApiAdminV1RepositoryRepositoryFilesListQuery(undefined);

  return (
    <Modal open={props.open} onClose={props.onClose} size="fullscreen" style={{ height: '700px' }}>
      <Header icon="linkify" content="Manage Resources" />
      <Modal.Content>
        <RepositoryContentList
          data={data!!}
          editable={false}
          onRowClick={repositoryFile => props.onItemClicked(repositoryFile)}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={props.onClose}>Done</Button>
      </Modal.Actions>
    </Modal>
  );
};

export default RepositoryContentListModal;
